import { render, staticRenderFns } from "./TeamMemberships.vue?vue&type=template&id=3732df12&"
import script from "./TeamMemberships.vue?vue&type=script&lang=js&"
export * from "./TeamMemberships.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberships.vue?vue&type=style&index=0&id=3732df12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports